export var en_US = {
  formats: {
    date: "mm/dd/yyyy"
  },
  texts: {
    "component.input_date.placeholder": "MM/DD/YYYY"
  }
};